/* Cookie utility functions */

// get user cookie by name
function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
  }
  return '';
}

// set a cookie. omit exdays for a session cookie
function setCookie(name, value, exdays) {
    var cookie;
    var cname = encodeURIComponent(name);
    var cvalue = encodeURIComponent(value);
    var path = '; path=/';
    var exdate = new Date();
    cookie = cname + '=' + cvalue;
    if (exdays !== undefined) {
      exdate.setDate(exdate.getDate() + exdays);
      cookie += '; expires=' + exdate.toUTCString();
    }
    cookie += path;
    document.cookie = cookie;
}   

// Delete session cookie
function eraseCookie(name) {
  setCookie(name,'deleted', -1);
}